"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeBasePath = removeBasePath;
var _hasBasePath = require("./has-base-path");
var basePath = process.env.__NEXT_ROUTER_BASEPATH || '';
function removeBasePath(path) {
  if (process.env.__NEXT_MANUAL_CLIENT_BASE_PATH) {
    if (!(0, _hasBasePath).hasBasePath(path)) {
      return path;
    }
  }
  path = path.slice(basePath.length);
  if (!path.startsWith('/')) path = "/".concat(path);
  return path;
}
if ((typeof exports.default === 'function' || _typeof(exports.default) === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}